import { render, staticRenderFns } from "./PreCounseling.vue?vue&type=template&id=c9550ca8&lang=pug&"
import script from "./PreCounseling.vue?vue&type=script&lang=ts&"
export * from "./PreCounseling.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports